export enum RoundOffType {
  DOWN,
  UP,
}

export enum RoundPrecisionUnit {
  Pallet,
  Bag,
}
